import { useState ,useEffect} from "react";
import { AGENT_ACTIVITY } from "../utils/ApiUrls";
import useFetch from "../hooks/useFetch";
import { TopDisappearingMessage } from "../utils/Common";
import Swal from "sweetalert2";




const BreakReasonPopup = ({ onSelect, setReasonPopUp, setOnlineStatus, breakReasons = [], setOnlineStatusColour, setIsEnabled, unregister, setIsOnPbxCall }) => {
    const fetchData = useFetch();
    const [reason, setReason] = useState("");
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        if (breakReasons.length === 0) {
            confirmBreak();
        }
    }, []);
    const confirmBreak = async () => {
        const currentBreakReason = localStorage.getItem("breakReason")
        if (currentBreakReason === reason) {
            Swal.fire({
            icon: "warning",
            title: "Already on Break",
            text: breakReasons.length === 0
                ? "You are already on a break."
                : "You have already selected this break reason. Please select another break reason.",
            confirmButtonText: "OK",
            });
            if (breakReasons.length === 0) {
                setReasonPopUp(false);
                setIsEnabled(false);
            }
            return;
        }
        setLoading(true);
        try{
            const res_data = await fetchData("post", { "status": "break", "usertype": "agent", "reason": reason },
                AGENT_ACTIVITY
            );

            // alert(JSON.stringify(res_data))

            if(res_data?.status!=="success"){
                throw new Error("Status Update Failed")
            }

            setOnlineStatus("break");
            localStorage.setItem("onlineStatus", "break");
            TopDisappearingMessage(
                "top-start",
                2000,
                "warning",
                "You are not available to make calls",
                false
            );

            if (onSelect) onSelect(reason); // send to parent if needed
            setReasonPopUp(false);
            setOnlineStatusColour("break")
            setIsEnabled(false);
            unregister();
            // A stale "on call" flag (e.g. a lost websocket call-end message) must
            // not survive an explicit "I'm done" signal from the agent.
            setIsOnPbxCall?.(false);
            console.log("Break reason set to:", reason);
            localStorage.setItem('sipEnabled', 'false')
            localStorage.setItem('breakReason', reason);
        }catch(err){
            console.log(`Agent activity change ${err}`)

            const msg = err?.message || "Unable to Change Status. Please try again"

            Swal.fire({
                title: "Status Change Failed",
                text: "Unable to Change Status. Please try again",
                confirmButtonColor: "#3085d6",
                icon: 'warning'
            })
        }
        setLoading(false);
    };
    if (breakReasons.length === 0) {
        return <></>;
    }

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">

            {/* Popup Container */}
            <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl w-[95%] sm:w-[450px] md:w-[520px] p-6 animate-fadeIn">

                {/* Title */}
                <h2 className="text-2xl font-semibold text-gray-800 dark:text-gray-200 text-center mb-6">
                    Choose Break Reason
                </h2>

                {/* Dropdown */}
                <div className="mb-6">
                    <label className="block text-gray-700 dark:text-gray-300 mb-2 font-medium">
                        Select Reason
                    </label>

                    <select
                        className="w-full p-3 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none bg-gray-50 dark:bg-gray-700 text-gray-800 dark:text-gray-200 transition-all"
                        value={reason}
                        onChange={(e) => setReason(e.target.value)}
                    >
                        <option value="">-- Select --</option>
                        {breakReasons.map((r, idx) => (
                            <option key={idx} value={r.reason}>
                                {r.reason}
                            </option>
                        ))}
                    </select>
                </div>

                {/* Buttons */}
                <div className="flex justify-end gap-3 mt-4">

                    <button
                        onClick={() => setReasonPopUp(false)}
                        className="px-5 py-2.5 rounded-lg bg-gray-300 hover:bg-gray-400 text-gray-800 font-medium transition-all"
                    >
                        Cancel
                    </button>

                    <button
                        onClick={confirmBreak}
                        className="px-5 py-2.5 rounded-lg bg-blue-600 hover:bg-blue-700 text-white font-medium transition-all"
                        disabled={loading}
                    >
                        Confirm
                    </button>
                </div>

            </div>
        </div>
    );
};

export default BreakReasonPopup;
